import React from "react";
import { computeFieldWinds } from "../utils/computeFieldWinds";

/**
 * ********************************************************
 * Child fuunction components for 
 * NAVLOG departure settings (field elevation, local altimeter, 
 * local OAT, takeoff fuel, wind direction/speed, runway heading)
 * 
 * ****************************************************************
 * 
 */

function NavlogDepartureSettings({
  departElevation,
  setDepartElevation,
  localAltimeter,
  setLocalAltimeter,
  localOat,
  setLocalOat,
  startFuel,
  setStartFuel,
  windDirection,
  setWindDirection,
  windSpeed,
  setWindSpeed,
  runwayHeading,
  setRunwayHeading,
}) {

    const fieldWinds = computeFieldWinds({
    windDirection,
    windSpeed,
    runwayHeading,
  });

  return (
    <>
      <h3 className="navlog-text-grid">
        NAVLOG Settings (values to be updated by user)
      </h3>

      <div className="navlog-departure-grid">
        <label>Field Elevation (MSL)</label>
        <input
          value={departElevation}
          onChange={(e) => setDepartElevation(e.target.value)}
        />

        <label>Local Altimeter (inHg)</label>
        <input
          value={localAltimeter}
          onChange={(e) => setLocalAltimeter(e.target.value)}
        />

        <label>Local OAT (°C)</label>
        <input
          value={localOat}
          onChange={(e) => setLocalOat(e.target.value)}
        />

        <label>Takeoff Usable Fuel (gal)</label>
        <input
          value={startFuel}
          onChange={(e) => setStartFuel(e.target.value)}
        />
        </div>
        <br></br>
        
        <div className="navlog-departure-container">
        <label>Wind Direction</label>
        <input
          className="field-wind-input"
          value={windDirection}
          onChange={(e) => setWindDirection(e.target.value)}
        />
          <label className="navlog-units">degrees</label>
      </div>

      <div className="navlog-departure-container">
        <label>Wind Speed</label>
        <input
          className="field-wind-input"
          value={windSpeed}
          onChange={(e) => setWindSpeed(e.target.value)}
        />
        <label className="navlog-units">kts.</label>
      </div>

      <div className="navlog-departure-container">

        <label>Runway Heading</label>

        <input
          className="field-wind-input"
          value={runwayHeading}
          onChange={(e) => setRunwayHeading(e.target.value)}
        />

        <label className="navlog-units">degrees</label>

      </div>
        

      
       <div className="field-wind-container">
        <div className="field-wind-box">
          <span className="field-wind-value">
            {fieldWinds.headwindLabel}
          </span>
        </div>

        <div className="field-wind-box">
          <span className="field-wind-value">
            {fieldWinds.crosswindLabel}
          </span>
        </div>

      </div>
    </>
  );
}

export default NavlogDepartureSettings;